export const pushHeaderTitle = (title = '') => {
    document.title = 'Kids-Matin - Grand journal pour petits génies';

    if ( typeof title !== 'undefined' && title !== '' ) {
        document.title = title +  ' - Kids-Matin';
    }
}


// WEBPACK FOOTER //
// ./src/utils/dom/helper.js